import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select, { components } from "react-select";
import SpinnerLoader from "../spinner-loader";

export default function MobileSelect({
  item = {},

  user,
  countryCode,
  countryCodesArr,
  setCountryCode,
  handleBlur,
  handleChange,
  values,
  errors,
  touched,
  isEditable = true,
  formik,

  isDisabled = false,
  hasError = false,
  hint = "",
  suffix,
  isShowSuffix = false,
  showLoader = false,
  showCancelButton = false,
}: any) {
  const { t } = useTranslation();

  const handleScrollOrArrowKey = (e: any) => {
    console.log("scrolling or arrow key pressed");
    e.target.blur();
    e.preventDefault();

    e.stopPropagation();

    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <div className="mobile-info">
      {" "}
      {item?.labelName && (
        <div className="membership-modal-input-label">
          {t("profile_info_labels." + item?.labelName, item?.labelName)}
        </div>
      )}
      <div
        className="mobile-select"
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <div
          className="input-container"
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            className={`d-flex input-select .input ${
              hasError ? "error" : "inputfocus"
            }`}
            style={{
              borderRadius: "4px",
              gap: "8px",
              background: `${
                isDisabled
                  ? "var(--LightTheme-Background-primary_background)"
                  : "var(--LightTheme-White-White)"
              }`,
              padding: "8px",
            }}
          >
            <PopoutExample
              disabled={isDisabled}
              countryCodesArr={countryCodesArr}
              countryCode={countryCode}
              setCountryCode={setCountryCode}
            />

            <input
              onWheel={(e) => {
                handleScrollOrArrowKey(e);
              }}
              onKeyDown={(e) => {
                console.log("scrollingor", e.key);
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                  handleScrollOrArrowKey(e);
                }
              }}
              disabled={isDisabled}
              type="number"
              name={`mobile`}
              value={values?.mobile}
              placeholder={t("common.phoneNumber")}
              // hasError={touched?.mobile != null && errors?.mobile != null}
              style={{
                opacity: !isEditable ? ".5" : "1",
                color: `${
                  isDisabled
                    ? "var(--LightTheme-Disable)"
                    : "var(--LightTheme-primary_text)"
                }`,
                outline: "none",
                border: "none",
                width: "100%",
                background: "transparent",
              }}
              onChange={handleChange}
              onBlur={handleBlur}
            />

            {showCancelButton && values?.mobile && (
              <div
                style={{ fontSize: "10px", cursor: "pointer" }}
                className="btn-close"
                // onClick={handleClearInput}
              ></div>
            )}
            {showLoader && (
              <div
                className="suffix-btn"
                style={{ width: "30px", height: "30px" }}
              >
                <SpinnerLoader />
              </div>
            )}

            {suffix && isShowSuffix && (
              <div className="suffix-btn">{suffix}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
const selectStyles = {
  control: (provided: any) => ({
    ...provided,
    minWidth: 240,
    margin: 8,
    background: "var(--LightTheme-Input-input_background)",
  }),
  menu: () => ({
    boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  }),
  option: (provided: any, state: any) => ({
    margin: "5px",
    padding: "5px",
    backgroundColor: state.isFocused
      ? "var(--LightTheme-Secondary)"
      : state.isSelected
      ? "var(--LightTheme-Input-input_background)"
      : "var(--LightTheme-Input-input_background)",
    color: state.isFocused
      ? "var(--LightTheme-Input-input_background)"
      : state.isSelected
      ? "var(--LightTheme-Black-Black)"
      : "var(--LightTheme-Black-Black)",
  }),
};

const PopoutExample = ({
  countryCodesArr,
  countryCode,
  setCountryCode,
  disabled = false,
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(countryCodesArr[0]);

  useEffect(() => {
    setValue(countryCodesArr.find((c: any) => c.value === countryCode));
  }, [countryCode, countryCodesArr]);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  const onSelectChange = (selectedValue: any) => {
    toggleOpen();
    setCountryCode(selectedValue?.value);
    setValue(selectedValue);
  };
  console.log("popout", value, countryCodesArr[0]);
  return (
    <Dropdown
      isOpen={disabled ? false : isOpen}
      onClose={toggleOpen}
      target={
        <button
          style={{
            border: "none",
            outlineColor: "transparent",
            background: "transparent",
          }}
          // iconAfter={<ChevronDown />}
          onClick={toggleOpen}
          // isSelected={isOpen}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <div
              className="country-flag"
              style={{ fontSize: "27px", fontFamily: "Twemoji Country Flags" }}
            >
              {value ? value?.flag : countryCodesArr[0]?.flag}
            </div>
            <span
              style={{
                color: `${
                  disabled
                    ? "var(--LightTheme-Disable)"
                    : "var(--LightTheme-primary_text)"
                }`,
              }}
            >
              {value ? value?.value : countryCodesArr[0]?.value}
            </span>
            <i className="fa fa-angle-down text-muted mr-1 p-0" />
          </span>
        </button>
      }
    >
      <Select
        autoFocus
        backspaceRemovesValue={false}
        components={{
          DropdownIndicator,
          IndicatorSeparator: null,
          Option: (props) => {
            console.log("countryprops", props);
            return (
              <>
                <components.Option {...props}>
                  <div
                    className="d-flex justify-content-start align-items-center gap-2"
                    role="button"
                  >
                    {/* <img src={country.image} alt="country-image" /> */}
                    <div
                      className="img img-fluid w-40 h-40  p-0 "
                      style={{ fontFamily: "Twemoji Country Flags" }}
                    >
                      {props?.data?.flag}
                    </div>
                    <span> {props?.data?.label}</span>
                  </div>
                </components.Option>

                <div
                  style={{
                    borderBottom: "solid 1px var(--LightTheme-Disable)",
                    width: "96%",
                    margin: "auto",
                  }}
                />
              </>
            );
          },
        }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        onChange={onSelectChange}
        options={countryCodesArr}
        placeholder="Search Country"
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
  );
};

// Styled components
const Menu = (props: any) => {
  const shadow = "hsla(218, 50%, 10%, 0.1)";
  console.log("menuprops", props);
  return (
    <div
      style={{
        backgroundColor: "var(--LightTheme-Input-input_background)",
        borderRadius: 4,
        boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
        marginTop: 8,
        position: "absolute",
        zIndex: 2,
      }}
      {...props}
    ></div>
  );
};

const Blanket = (props: any) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: "fixed",
      zIndex: 1,
    }}
    {...props}
  />
);

const Dropdown = ({ children, isOpen, target, onClose }: any) => {
  console.log("dropdown", children);
  return (
    <div style={{ position: "relative" }}>
      {target}
      {isOpen ? <Menu>{children}</Menu> : null}
      {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
  );
};

const Svg = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...props}
  />
);

const DropdownIndicator = () => (
  <div
    style={{
      color: "var(--LightTheme-Input-input_background)",
      height: 24,
      width: 32,
    }}
  >
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);
